// oxlint-disable-next-line no-restricted-imports -- TODO(zod-4): migrate to 'zod/v4'
import type { ZodEnum } from 'zod';

export function parseSort<T extends [string, ...string[]]>(schema: ZodEnum<T>, value: unknown) {
  const result = schema.safeParse(value);

  if (!result.success) {
    return undefined;
  }

  return result.data;
}
